import BpkLink from '@skyscanner/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './ViewMoreReviewsLink.module.scss';

import { useReviewDetailLink } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { FormattedMessage } from '@shared/ui/components/i18n';

const cls = cssModules(STYLES);

const ViewMoreReviewsLink = () => {
  const href = useReviewDetailLink();
  if (!href) return null;

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) => (
        <BpkLink
          target="_blank"
          href={href}
          className={cls('ViewMoreReviewsLink')}
        >
          <BpkText
            textStyle={isMobile ? TEXT_STYLES.xs : TEXT_STYLES.base}
            color={TEXT_COLORS.textSecondary}
          >
            <FormattedMessage
              label="TA_more_reviews_label"
              data={{ vendor: 'Tripadvisor' }}
            />
          </BpkText>
        </BpkLink>
      )}
    </BpkBreakpoint>
  );
};

export default ViewMoreReviewsLink;
